import LoaderIcon from "@/assets/loader.svg?react";

export const Loader = () => {
  return (
    <div className="fixed inset-0 flex justify-center items-center z-50 pointer-events-none">
      <LoaderIcon className="text-gray-400 animate-pulse size-20" />
    </div>
  );
};
